/**
 * Which stops need an index PATCH so the server matches the given order.
 *
 * Reordering used to PATCH every stop of the route, unchanged ones included,
 * and each PATCH triggers a full routing snapshot rewrite on the backend. Only
 * the stops whose position actually moved are returned here. Kept free of Vue
 * and axios imports so it can be exercised with plain node.
 */
export function diffStopIndexes(stops) {
  const changes = []
  ;(stops || []).forEach((stop, position) => {
    if (!stop || stop.id == null) return
    if (Number(stop.index) !== position) {
      changes.push({ id: stop.id, index: position })
    }
  })
  return changes
}
